<form  [formGroup]="underutilization">
  <!-- {{underutilization.value | json}} -->
<vue-text-input
    label="{{ 'label.alerts' | translate | async }}"
    formControlName="alertname"
    [required]="true"
[errorMatcher]="poolNameErrorMatcher"
    errorMessage="{{ poolNameErrorMessageKey() | translate | async }}"
  ></vue-text-input>
   <vue-select
    label="{{ 'title.queue' | translate | async }}"
    [required]="true"
    formControlName="Queue"
    [options]="queues"
    [getOptionDisplay]="getQueueDisplay"
  ></vue-select>
  <h1 style="position: relative;
    top: -9px;">Alert Condition</h1>
  <app-alert-condition  formControlName="Time"></app-alert-condition>
 

 
  <div style="display: flex; margin-top: 15px; align-items: baseline;">
    <h3 style="font-weight: bold;">Execution Time*</h3>
    <vue-image-tooltip  imageSrc="/assets/icons/icon-exclamation.svg"
          content="{{ 'tooltip.message.underutlization.executive.hours' | translate | async }}"></vue-image-tooltip>
    <!-- <vue-select class="depo"
    formControlName="executive"
    [required]="true"
  ></vue-select> -->
      <vue-select class="depos"
                 
                  label="Time"
                  formControlName="executive" [required]="true" [options]="utcStartTimes"
                  [getOptionDisplay]="addUTCToTime.bind(this)"
                  [errorMatcher]="suppressErrorState"></vue-select>
  </div>

  <div style="display: flex; align-items: baseline; margin-top: 2px;" >
    <h3 style="font-weight: bold;">Email*</h3>
     <mat-form-field  class="depo" appearance="outline" style="width:290px; margin-left: 12px;">
        <input matInput type="text" placeholder="Email..." formControlName="Email">
    </mat-form-field>
  </div>
</form>

